import helper from "../../../../../utils/helper";

const Details = ({ detalhes, setDetalhes }) => {
    const handle = (e) => {
        const { id, value } = e.target;

        setDetalhes((prev) => ({
            ...prev,
            [id]: value,
        }));

        const span = document.querySelector(`#validacao-${id}`);
        if (span) span.innerHTML = "";
    };

    return (
        <form className="hdv-form-default" style={{ marginBottom: '2rem' }}>
            <label htmlFor="nome_fantasia">
                <i
                    className="las la-info-circle"
                    style={{ cursor: "pointer", marginRight: '3px' }}
                    title='Informações básicas'
                    onClick={() =>
                        helper.dispatchEvent("showAviso", {
                            message: "As informações básicas da empresa estão disponíveis apenas para leitura. Caso precise realizar alguma alteração, entre em contato com o suporte."
                        })
                    }
                />
                Nome Fantasia
            </label>
            <input
                type="text"
                name="nome_fantasia"
                id="nome_fantasia"
                value={detalhes.nome_fantasia || ""}
                onChange={handle}
                disabled
            />
            <span id="validacao-nome_fantasia"></span>

            <details
                open={true}
                style={{ marginTop: "20px" }}
                className="custom-summary"
            >
                <summary>Opcionais</summary>

                <div style={{ padding: "0px 10px 10px 10px" }}>

                    <label htmlFor="razao_social">Razão Social</label>
                    <input
                        type="text"
                        name="razao_social"
                        id="razao_social"
                        value={detalhes.razao_social || ""}
                        onChange={handle}
                        disabled
                    />
                    <span id="validacao-razao_social"></span>

                    <label htmlFor="pessoa_tipo">Pessoa Tipo</label>
                    <div className="d-flex">
                        <label className="hdv-fixed">
                            <input
                                type="radio"
                                name="pessoa_tipo"
                                id="pessoa_tipo"
                                value="fisica"
                                checked={detalhes.pessoa_tipo === "fisica"}
                                onChange={handle}
                                disabled
                            />
                            Física
                        </label>

                        <label className="hdv-fixed">
                            <input
                                type="radio"
                                name="pessoa_tipo"
                                id="pessoa_tipo"
                                value="juridica"
                                checked={detalhes.pessoa_tipo === "juridica"}
                                onChange={handle}
                                disabled
                            />
                            Jurídica
                        </label>
                    </div>
                    <span id="validacao-pessoa_tipo"></span>

                    <br />

                    <label htmlFor="cpf_cnpj">CPF / CNPJ</label>
                    <input
                        type="text"
                        name="cpf_cnpj"
                        id="cpf_cnpj"
                        value={detalhes.cpf_cnpj || ""}
                        onChange={handle}
                        disabled
                    />
                    <span id="validacao-cpf_cnpj"></span>
                </div>
            </details>
        </form>
    );
};

export default Details;